import React, { createContext, useContext } from 'react'
import { type PermissionsConfig } from '#app/config'

export const PermissionsContext = createContext<PermissionsConfig | null>(null)

export function PermissionsProvider({ permissions, children }: { permissions: PermissionsConfig; children: React.ReactNode }) {
  return <PermissionsContext.Provider value={permissions}>{children}</PermissionsContext.Provider>
}

export function usePermissionsContext(): PermissionsConfig | null {
  return useContext(PermissionsContext)
}
